module.exports = __webpack_public_path__ + "img/userimg.6ecf240a.jpeg";